// src/components/PrivateRoute.tsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Loader from '../loader';

interface Props {
  /** Lista de cargos/papéis permitidos. Se vazio → qualquer usuário logado. */
  roles?: string[];
}

const PrivateRoute: React.FC<Props> = ({ roles }) => {
  const { isAuthenticated, user, isBootstrapping } = useAuth();

  /* 0) Se estiver restaurando sessão, aguarda (Loader ou null) */
  if (isBootstrapping) {
    return <Loader />;
  }

  /* 1) Não logado → volta para login */
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  /* 2) Logado mas não tem papel exigido → página de acesso negado */
  if (roles && user && !roles.map(r => r.toLowerCase()).includes(user.role.toLowerCase())) {
    return <Navigate to="/unauthorized" replace />;
  }

  /* 3) Autorizado → renderiza as rotas filhas */
  return <Outlet />;
};

export default PrivateRoute;
